import { request } from '@/utils/ajax'
import { LocalizedEnum, ItemCategory } from '@/types';

export function getAllItemCategories(): Promise<ItemCategory[]> {
    return request(`api/item-category`).then(x => x.json());
}

export function getProjectCategoryPermissionTypes(): Promise<LocalizedEnum[]> {
    return request(`api/item-category/permission-types`).then(x => x.json());
}
